import { DEFAULT_BAR_COLORS, DEFAULT_COLOR, DEFAULT_DECIMALS } from '../constants';

import type { StanBarChartProps, UseStanBarChartOptionsResult } from '../types';

import { useApexChart } from '@/hooks/useApexChart';
import styles from '../StanBarChart.module.css';

/**
 * Hook to generate ApexCharts configuration for bar charts.
 * Handles color palettes, tooltips, formatting, and responsive options.
 */
export function useStanBarChartOptions({
    series,
    customOptions,
    chartPrefix = '',
    dataSuffix = '',
    decimals,
    stacked = false,
    tooltipFormatter,
    showStanBrandingInTooltip = true,
    categories,
    yAxisMin,
    yAxisMax,
    color,
    borderRadius,
}: StanBarChartProps): UseStanBarChartOptionsResult {
    const result = useApexChart({
        variant: 'bar',
        series,
        customOptions,
        chartPrefix,
        dataSuffix,
        decimals: decimals ?? DEFAULT_DECIMALS,
        stacked,
        tooltipFormatter,
        showStanBrandingInTooltip,
        categories,
        yAxisMin,
        yAxisMax,
        paletteConfig: {
            defaultColors: DEFAULT_BAR_COLORS,
            defaultColor: DEFAULT_COLOR,
            customColor: color,
        },
        borderRadius,
        brandedTooltipClassName: styles.brandedTooltip || '',
    });
    return {
        options: result.options,
        resolvedSeries: result.resolvedSeries,
    };
}
